import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _changePasswordRequest = {};
var _commonCustomValue = {
    numValue: 'DOUBLE',
    dateValue: 'google.protobuf.Timestamp',
    listValue: '_commonListValue',
    mapValue: '_commonMapValue',
};
var _commonListValue = { value: '_commonCustomValue' };
var _commonMapValue = { value: 'Map#_commonCustomValue' };
var _customField = { value: '_customValue' };
var _customValue = {
    numValue: 'DOUBLE',
    dateValue: 'google.protobuf.Timestamp',
    listValue: '_listValue',
    mapValue: '_mapValue',
};
var _identity = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    identityProfile: '_identityProfile',
};
var _identityProfile = { customFields: '_customField' };
var _listValue = { value: '_customValue' };
var _loginCallbackRequest = {};
var _loginRequest = {};
var _loginResponse = {
    identity: '_identity',
    additionalData: 'Map#_customValue',
};
var _loginV2Request = {};
var _loginWithIdpConnectionRequest = {};
var _loginWithIdpConnectionTokenParamsRequest = {};
var _logoutRequest = {};
var _mapValue = { value: 'Map#_customValue' };
var _proceedToNextStateRequest = {};
var _rawHttpRequest = { body: 'BYTES' };
var _rawHttpResponse = { body: 'BYTES' };
var _registerRequest = { identity: '_identity' };
var _registerV2Request = { profile: '_identityProfile' };
var _signOnRequest = { profile: '_identityProfile' };
var _signOnResponse = { identity: '_identity' };
var _stateMachineResponse = {
    identity: '_identity',
    additionalData: 'Map#_commonCustomValue',
};
function resolveWixIamAuthenticationV1AuthenticationServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/iam/wix/google',
                destPath: '/v1/sso/callback/root/0e6a50f5-b523-4e29-990d-f37fa2ffdd69',
            },
            {
                srcPath: '/authentication',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/authentication',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/iam/authentication',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function register(payload) {
    var _a = serializer(_registerRequest, {
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_loginResponse, {
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __register(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.Register',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/register',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __register.fromReq = fromReq;
    return __register;
}
register.__isAmbassador = true;
export function login(payload) {
    var _a = serializer(_loginRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_loginResponse, {
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __login(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.Login',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/login',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __login.fromReq = fromReq;
    return __login;
}
login.__isAmbassador = true;
/**
 * Registers a new member.
 *
 * Typically, after a sucessful registration, you generate and use member tokens for the
 * registered member so that subsequent API calls are called as part of a member session.
 *
 * If the email used to register the member already exists as a contact email, the registering
 * member need to verify the email address using a code that is sent to the address.
 */
export function registerV2(payload) {
    var _a = serializer(_registerV2Request, {
        _customField: _customField,
        _customValue: _customValue,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_stateMachineResponse, {
        _commonCustomValue: _commonCustomValue,
        _commonListValue: _commonListValue,
        _commonMapValue: _commonMapValue,
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __registerV2(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.RegisterV2',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v2/register',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __registerV2.fromReq = fromReq;
    return __registerV2;
}
registerV2.__isAmbassador = true;
/**
 * Logs in an existing user.
 *
 * Typically, after a sucessful login, you generate and use member tokens for the
 * logged-in member so that subsequent API calls are called as part of a member session.
 */
export function loginV2(payload) {
    var _a = serializer(_loginV2Request, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_stateMachineResponse, {
        _commonCustomValue: _commonCustomValue,
        _commonListValue: _commonListValue,
        _commonMapValue: _commonMapValue,
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __loginV2(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.LoginV2',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v2/login',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __loginV2.fromReq = fromReq;
    return __loginV2;
}
loginV2.__isAmbassador = true;
/** Changes the password of a logged in user. */
export function changePassword(payload) {
    var _a = serializer(_changePasswordRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_changePasswordRequest, {}).fromJSON;
    function __changePassword(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.ChangePassword',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v2/change-password',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __changePassword.fromReq = fromReq;
    return __changePassword;
}
changePassword.__isAmbassador = true;
export function loginWithIdpConnection(payload) {
    var _a = serializer(_loginWithIdpConnectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __loginWithIdpConnection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'GET',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.LoginWithIdpConnection',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/sso/login/{tenantId}/{idpConnectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                        protoPath: '/v1/sso/login/{tenantId}/{idpConnectionId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __loginWithIdpConnection.fromReq = fromReq;
    return __loginWithIdpConnection;
}
loginWithIdpConnection.__isAmbassador = true;
/** REQUIRES path params `tenant_type`, `tenant_id` and `idp_connection_id` */
export function loginWithIdpConnectionCallback(payload) {
    var _a = serializer(_rawHttpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __loginWithIdpConnectionCallback(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'GET',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.LoginWithIdpConnectionCallback',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/sso/callback/{tenantType}/{tenantId}/{idpConnectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                        protoPath: '/v1/sso/callback/{tenantType}/{tenantId}/{idpConnectionId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __loginWithIdpConnectionCallback.fromReq = fromReq;
    return __loginWithIdpConnectionCallback;
}
loginWithIdpConnectionCallback.__isAmbassador = true;
export function loginCallback(payload) {
    var _a = serializer(_loginCallbackRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __loginCallback(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'GET',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.LoginCallback',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/callback',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __loginCallback.fromReq = fromReq;
    return __loginCallback;
}
loginCallback.__isAmbassador = true;
export function loginWithIdpConnectionTokenParams(payload) {
    var _a = serializer(_loginWithIdpConnectionTokenParamsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_stateMachineResponse, {
        _commonCustomValue: _commonCustomValue,
        _commonListValue: _commonListValue,
        _commonMapValue: _commonMapValue,
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __loginWithIdpConnectionTokenParams(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.LoginWithIdpConnectionTokenParams',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/sso/login-with-token-params',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __loginWithIdpConnectionTokenParams.fromReq = fromReq;
    return __loginWithIdpConnectionTokenParams;
}
loginWithIdpConnectionTokenParams.__isAmbassador = true;
export function proceedToNextState(payload) {
    var _a = serializer(_proceedToNextStateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_loginResponse, {
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __proceedToNextState(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.ProceedToNextState',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/state/proceed',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __proceedToNextState.fromReq = fromReq;
    return __proceedToNextState;
}
proceedToNextState.__isAmbassador = true;
export function signOn(payload) {
    var _a = serializer(_signOnRequest, {
        _customField: _customField,
        _customValue: _customValue,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_signOnResponse, {
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __signOn(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'POST',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.SignOn',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v2/sign-on',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __signOn.fromReq = fromReq;
    return __signOn;
}
signOn.__isAmbassador = true;
/** Logs out a member. */
export function logout(payload) {
    var _a = serializer(_logoutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __logout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.authentication.v1.authentication',
            method: 'GET',
            methodFqn: 'wix.iam.authentication.v1.AuthenticationService.Logout',
            url: resolveWixIamAuthenticationV1AuthenticationServiceUrl({
                protoPath: '/v1/logout',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __logout.fromReq = fromReq;
    return __logout;
}
logout.__isAmbassador = true;
//# sourceMappingURL=http.impl.js.map